import React from "react";
import styled, { keyframes } from "styled-components/macro";
import { useEvents } from "../hooks/useEvents";
import UpcomingEventModule from "../modules/UpcomingEventModule";

const shimmer = keyframes`
  0%   { background-position: -400px 0; }
  100% { background-position:  400px 0; }
`;

const SkeletonCard = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  background: ${({ theme }) => theme.colors.primaryBackground};
  padding: ${({ theme }) => theme.spacing.md};
  box-shadow: ${({ theme }) => theme.boxShadow.accountCard};
`;

const SkeletonBar = styled.div`
  border-radius: 6px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e4e4e4 50%, #f0f0f0 75%);
  background-size: 800px 100%;
  animation: ${shimmer} 1.4s infinite;
  height: ${({ height }) => height || "13px"};
  width: ${({ width }) => width || "100%"};
  margin-bottom: ${({ mb }) => mb || "8px"};
`;

function UpComingEventSkeleton() {
  return (
    <SkeletonCard>
      <SkeletonBar height="16px" width="50%" mb="12px" />
      <SkeletonBar height="13px" width="75%" mb="8px" />
      <SkeletonBar height="13px" width="60%" mb="8px" />
      <SkeletonBar height="13px" width="40%" mb="0" />
    </SkeletonCard>
  );
}

export default function UpComingEventCard() {
  const { status, data } = useEvents();
  const isLoading = status === "idle" || status === "fetching";

  return (
    <>
      {isLoading ? (
        <UpComingEventSkeleton />
      ) : (
        <UpcomingEventModule data={data} />
      )}
    </>
  );
}
